module.exports = __webpack_public_path__ + "img/dimensions_example.b1cb9700.png";